import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetcher, throwApiError } from '@commenda/utils';

import { adminManagedAgentsKeys } from './keys';

export function useDeleteAdminManagedAgent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const response = await fetcher(`admin/managed-agents/${id}`, {
        method: 'DELETE',
      });
      if (!response.ok)
        await throwApiError(response, 'Failed to delete the managed agent');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: adminManagedAgentsKeys.lists(),
      });
    },
  });
}
